import { useQuery } from "@tanstack/react-query";
import { getAllAttendanceHistory } from "src/redux/api/_hr_attendance.api";
import { AttendanceType } from "src/redux/types/_attendance.type";

export const useAttendanceByEmployeeCode = (employeeCode?: number) => {
  return useQuery<AttendanceType[]>({
    queryKey: ["attendance", employeeCode],

    queryFn: async () => {
      const res = await getAllAttendanceHistory({
        employee_code: employeeCode,
      });

      if (res.message?.toLowerCase() !== "success") {
        throw new Error("Failed to fetch attendance records.");
      }

      return res.data?.attendance ?? [];
    },

    enabled: !!employeeCode,

    staleTime: 1000 * 60,
  });
};

